<template>
    <el-tabs v-model="activeState" class="demo-tabs" @tab-change="handleClick">
        <el-tab-pane label="停车场" :name="0">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="场站名称：">
                    <el-select
                        filterable
                        v-model="selectList1"
                        style="width: 240px"
                        placeholder="请选择场站"
                        collapse-tags
                        multiple
                        clearable
                        @change="e => changeSelect1(e)"
                    >
                        <div class="checkboxWrapper">
                        <el-checkbox v-model="checked1" @change="checkChange1">
                            全选
                        </el-checkbox>
                        </div>
                        <el-option
                        v-for="item in stationOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型：">
                    <el-select v-model="searchPark.barrierType" style="width: 240px" placeholder="请选择类型">
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="item in typeOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地上/地下：" prop="">
                    <el-select v-model="searchPark.upOrDown" style="width: 100px" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="item in upOrDownOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关键字">
                    <el-input v-model="searchPark.keyword" placeholder="请输入名称或编码" autocomplete="off" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList1">查询</el-button>
                    <el-button type="primary" @click="addSetting">新建</el-button>
                </el-form-item>
            </el-form>
            <el-table class="table_wrapper" :data="tableData1" @selection-change="handleSelectionChange" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
                <!-- <el-table-column type="selection" width="55" /> -->
                <el-table-column label="停车场名称" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.name }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="停车场编码" min-width="150" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.code }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="所属场站" min-width="150" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.stationName }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="道闸类型" min-width="150">
                    <template #default="scope">
                    <div>
                        <span>{{ barrierTypeFilter(scope.row.barrierType) }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="地上/地下" min-width="150">
                    <template #default="scope">
                    <div>
                        <span>{{ upOrDownFilter(scope.row.upOrDown) }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="停车减免" min-width="150">
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.parkCouponId }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="商户ID" min-width="150" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.merchantId }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="地址" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.address }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template #default="scope">
                    <el-button size="small" @click="parkEdit(scope.$index, scope.row)">
                        编辑
                    </el-button>
                    <!-- <el-button
                        size="small"
                        type="danger"
                        @click="parkDelete(scope.$index, scope.row)"
                    >
                        删除
                    </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage1"
                v-model:page-size="pageSize1"
                :total="total1"
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
            />
        </el-tab-pane>

        <el-tab-pane label="第三方平台" :name="1">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="类型：">
                    <el-select v-model="searchThird.type" style="width: 240px" placeholder="请选择类型">
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="item in typeOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList2">查询</el-button>
                    <el-button  type="primary" @click="addThirdBar">新建</el-button>
                </el-form-item>
            </el-form>
            <el-table class="table_wrapper" :data="tableData2" @selection-change="handleSelectionChange2" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
                <!-- <el-table-column type="selection" width="55" /> -->
                <el-table-column label="名称" min-width="150" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.name }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="类型" min-width="150">
                    <template #default="scope">
                    <div>
                        <span>{{ typeFilter(scope.row.type) }}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="应用ID" min-width="150" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.appId || '--'}}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="密钥" min-width="200" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.secret || '--'}}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="签名密钥" min-width="300" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{ scope.row.signKey || '--'}}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="客户编号" min-width="200" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{scope.row.customerId || '--'}}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="请求地址" min-width="200" show-overflow-tooltip>
                    <template #default="scope">
                    <div>
                        <span>{{scope.row.url || '--'}}</span>
                    </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template #default="scope">
                    <el-button size="small" @click="thirdEdit(scope.$index, scope.row)">
                        编辑
                    </el-button>
                    <!-- <el-button
                        size="small"
                        type="danger"
                        @click="thirdDelete(scope.$index, scope.row)"
                    >
                        删除
                    </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage2"
                v-model:page-size="pageSize2"
                :total="total2"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
            />
        </el-tab-pane>
    </el-tabs>

    <!-- 新建停车场 -->
    <el-drawer
        v-model="drawer"
        :title="drawerTitle"
        direction="rtl"
        :before-close="handleClose"
    >
    <el-form>
        <el-form-item label="道闸类型">
            <el-select :disabled="isUpdate" v-model="settingInfo.barrierType" placeholder="请选择道闸类型" @change="getConfigList(settingInfo.barrierType)">
                <el-option
                    v-for="item in barrierTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="道闸平台" v-if="settingInfo.barrierType">
            <el-select v-model="settingInfo.barrierId" placeholder="请选择道闸平台" @change="getThirdObjList(settingInfo.barrierId)">
                <el-option
                    v-for="item in configOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="选择同步场站" v-if="settingInfo.barrierId && settingInfo.barrierType==2">
            <el-select v-model="settingInfo.stationObjId" placeholder="请选择同步场站" @change="getThirdObj(settingInfo.stationObjId)">
                <el-option
                    v-for="item in thirdObjOptions"
                    :key="item.id"
                    :label="item.parkName"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="停车场名称">
            <el-input v-model="settingInfo.name" autocomplete="off" v-if="!isAnjubao" />
            <el-input v-model="settingInfo.name" autocomplete="off" v-if="isAnjubao" disabled />
        </el-form-item>
        <el-form-item label="停车场编码">
            <el-input v-model="settingInfo.code" autocomplete="off" v-if="!isAnjubao" />
            <el-input v-model="settingInfo.code" autocomplete="off" v-if="isAnjubao" disabled />
        </el-form-item>
        <el-form-item label="所属场站">
            <el-select v-model="settingInfo.stationId" placeholder="请选择所属场站">
                <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="停车减免">
            <el-select v-model="settingInfo.parkCouponId" placeholder="请选择停车减免">
                <el-option
                    v-for="item in couponOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="商户ID">
            <el-input v-model="settingInfo.merchantId" autocomplete="off" v-if="!isAnjubao" />
            <el-input v-model="settingInfo.merchantId" autocomplete="off" v-if="isAnjubao" disabled />
        </el-form-item>
        <el-form-item label="地上/地下：" prop="">
            <el-select v-model="settingInfo.upOrDown" placeholder="请选择地上/地下">
                <el-option
                    v-for="item in upOrDownOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="地址">
            <el-input v-model="settingInfo.address" autocomplete="off" v-if="!isAnjubao" />
            <el-input v-model="settingInfo.address" autocomplete="off" v-if="isAnjubao" disabled />
        </el-form-item>
        <el-form-item label="联系人">
            <el-input v-model="settingInfo.person" placeholder="类型为安居宝时必填" autocomplete="off" />
        </el-form-item>
        <el-form-item label="联系电话">
            <el-input v-model="settingInfo.tel" placeholder="类型为安居宝时必填" autocomplete="off" />
        </el-form-item>
    </el-form>
    <template #footer>
    <div class="dialog-footer">
        <el-button @click="closeAdd">取消</el-button>
        <el-button type="primary" @click="save()">确定</el-button>
    </div>
    </template>

    </el-drawer>

    <!-- 新建第三方平台 -->
    <el-drawer
        v-model="drawer2"
        :title="drawerTitle2"
        direction="rtl"
        :before-close="handleClose2"
    >
    <el-form>
        <el-form-item label="名称">
            <el-input v-model="thirdInfo.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="类型：" prop="">
            <el-select v-model="thirdInfo.type" :disabled="isUpdate" placeholder="请选择类型">
                <el-option
                    v-for="item in typeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="密钥">
            <el-input v-model="thirdInfo.secret" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密钥标识" v-if="thirdInfo.type == 2 && isUpdate">
            <el-input v-model="thirdInfo.secretId" autocomplete="off" disabled />
        </el-form-item>
        <el-form-item label="应用ID">
            <el-input v-model="thirdInfo.appId" autocomplete="off" />
        </el-form-item>
        <el-form-item label="请求地址">
            <el-input v-model="thirdInfo.url" autocomplete="off" />
        </el-form-item>
        <el-form-item label="签名密钥" v-if="thirdInfo.type == 2">
            <el-input v-model="thirdInfo.signKey" autocomplete="off" />
        </el-form-item>
        <el-form-item label="客户编号" v-if="thirdInfo.type == 1">
            <el-input v-model="thirdInfo.customerId" autocomplete="off" />
        </el-form-item>
    </el-form>
    <template #footer>
    <div class="dialog-footer">
        <el-button @click="closeAdd">取消</el-button>
        <el-button type="primary" @click="saveThird()">确定</el-button>
    </div>
    </template>

    </el-drawer>

</template>

<script>
import { ElMessage } from 'element-plus';
import { required, isPhoneValue } from '@/utils/validators';
    export default {
        name:'ThirdPark',
        data() {
            return {
                searchPark: { //查询第三方平台信息
                    upOrDown: '', //地上地下
                    barrierType: '', //道闸类型
                    keyword: '', //关键字
                },
                isAnjubao: false, //是否安居宝
                thirdObjOptions: [], //同步场站列表
                configOptions: [], //道闸平台列表
                couponOptions: [], //停车减免列表
                upOrDownOptions: [
                    {
                        id: 1,
                        name: '地上'
                    },
                    {
                        id: 2,
                        name: '地下'
                    },
                ],
                barrierTypeOptions: [
                    {
                        id: 1,
                        name: '捷停车'
                    },
                    {
                        id: 2,
                        name: '安居宝'
                    },
                ],
                searchThird: { //查询第三方平台信息
                    type: '', //类型
                },
                currtThird: {}, //当前第三方平台信息
                drawer: false,
                drawerTitle: '',
                settingInfo: { //信息
                    stationObjId: '', //场站对象ID
                    person: '', //联系人
                    tel: '', //联系电话
                    address: '', //地址
                    type: '', //类型
                    barrierType: '', //道闸类型
                    couponId: '', //停车减免ID
                    upOrDown: '', //地上地下
                    stationId: '', //场站ID
                    thirdId: '', //第三方平台ID
                    configId: '', //配置ID
                },
                drawer2: false,
                drawerTitle2: '',
                thirdInfo: { //第三方平台信息
                    name: '', //名称
                    type: '', //类型
                    secret: '', //密钥
                    secretId: '', //密钥标识
                    appId: '', //应用ID
                    url: '', //请求地址
                    signKey: '', //签名密钥
                    customerId: '', //客户编号
                },
                isUpdate: false, //是否修改
                isLoadData: false, //是否已加载数据
                total1: 0, //总条数
                currentPage1: 1, //当前页
                pageSize1: 10, //每页显示条数
                total2: 0, //总条数
                currentPage2: 1, //当前页
                pageSize2: 10, //每页显示条数
                stationOptions: this.$store.state.stationList,
                typeOptions: [
                    {
                        id: 1,
                        name: '捷停车'
                    },
                    {
                        id: 2,
                        name: '安居宝'
                    },
                ],
                selectList1: [],
                checked1: false,
                selectList2: [],
                checked2: false,
                selectList3: [],
                checked3: false,
                activeState: 0,
                tableData1:[
                    // {
                    //     stationName: 'Station1',
                    //     pileName: 'Pile1',
                    //     pileNo: 'PileNo1',
                    //     stationAddress: 'Address1' 
                    // }
                ],
                tableData2:[
                    // {
                    //     stationName: 'Station2',
                    //     pileName: 'Pile1',
                    //     pileNo: 'PileNo1',
                    //     stationAddress: 'Address1' 
                    // }
                ],
                selection: [],
                selection2: [],
            };
        },
        mounted() {
            this.getList1(); //获取列表
            this.getCouponList(); //获取停车减免列表
        },
        watch: {
            '$store.state.stationList': {
                handler(newVal) {
                    if (newVal && newVal.length > 0) {
                        this.stationOptions = newVal;
                    }
                },
                immediate: true
            }
        },
        methods: {
            thirdEdit(index, row) {
                //编辑第三方平台-配置信息
                let that = this;
                that.isUpdate = true;
                this.thirdInfo = JSON.parse(JSON.stringify(row));
                this.drawer2 = true;
                this.drawerTitle2 = '编辑第三方平台';
                // let param = {
                //     id: row.id,
                //     type: row.type,
                // }
                // that.$axios.post(that.$store.state.platformApi+"barrier/config/view", JSON.stringify(param)).then(result => {
                //     if(result.code==200){
                //     }
                // })
            },
            thirdDelete(index, row){
                this.$confirm('确定删除该第三方平台吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                    let param = {
                        id: row.id,
                    }
                    that.$axios.post(that.$store.state.platformApi+"barrier/config/delete", JSON.stringify(param)).then(result => {
                        if(result.code==200){
                            ElMessage({
                                message: '删除成功',
                                type:'success',
                            }); 
                            that.getList1(); //获取列表
                        }
                    })
                })
                .catch(_ => {});
            },
            closeAdd() {
                this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                    this.drawer = false;
                })
                .catch(_ => {});
            },
            handleClose(done) {
                this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            },
            handleClose2(done) {
                this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            },
            save() {
                //保存
                let that = this;
                let param = {};
                let url = '';
                param = that.settingInfo;
                if(that.isUpdate){
                    //修改
                    // param.ids = that.selection2.map(item => item.id);
                    url = that.$store.state.platformApi+"park/update";
                }else{
                    //新增
                    url = that.$store.state.platformApi+"park/add";
                    //移除参数中的parkCoupon字段
                    delete param.parkCoupon;
                }
                
                // console.log('param---',param);
                if(param.barrierType == 2){
                    if(!param.person){
                        ElMessage({
                            message: '请输入联系人',
                            type:'warning',
                        }); 
                        return;
                    }
                    if(!isPhoneValue(param.tel)){
                        ElMessage({
                            message: '请输入正确的联系电话',
                            type:'warning',
                        }); 
                        return;
                    }
                }
                that.$axios.post(url,JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        ElMessage({
                            message: '保存成功',
                            type: 'success',
                        });
                        that.drawer = false;
                        that.getList1(); //获取列表
                    }
                });
            },
            saveThird(){
                //保存
                let that = this;
                let param = {};
                let url = '';
                if(that.isUpdate){
                    //修改
                    url = that.$store.state.platformApi+"barrier/config/update";
                }else{
                    //新增
                    url = that.$store.state.platformApi+"barrier/config/add";
                }
                param = that.thirdInfo;
                if(that.thirdInfo.type == 1){
                    if(that.thirdInfo.customerId == null || that.thirdInfo.customerId.length==0){
                        ElMessage({
                            message: '请输入客户编号',
                            type:'warning',
                        }); 
                        return;
                    }
                }
                that.$axios.post(url,JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        ElMessage({
                            message: '保存成功',
                            type: 'success',
                        });
                        that.drawer2 = false;
                        that.getList2(); //获取列表
                    }
                });
            },
            addSetting() {
                this.drawerTitle = '添加停车场';
                this.isUpdate = false;
                this.isAnjubao = false;
                this.settingInfo = Object.fromEntries(  
                  Object.keys(this.settingInfo).map(key => [key, ''])
                );
                this.drawer = true;  
            },
            parkEdit(index, row){
                this.drawerTitle = '编辑停车场';
                this.isUpdate = true;
                this.drawer = true; 
                this.settingInfo = JSON.parse(JSON.stringify(row));
                this.getConfigList(this.settingInfo.barrierType); //获取道闸平台列表
                if(this.settingInfo.barrierType == 2){
                    this.isAnjubao = true;
                    this.getThirdObjList(this.settingInfo.barrierId); //获取第三方平台列表
                }
            },
            addThirdBar() {
                this.drawerTitle2 = '添加第三方平台';
                this.isUpdate = false;
                this.drawer2 = true;  
                this.thirdInfo = Object.fromEntries(
                  Object.keys(this.thirdInfo).map(key => [key, ''])
                );
            },
            handleSizeChange1 (val) { //每页显示条数
              this.pageSize1 = val;
              this.currentPage1 = 1;
              this.getList1();
            },
            handleCurrentChange1(val) { //当前页
                this.currentPage1 = val;
                this.getList1(); //获取列表
            },
            handleSizeChange2 (val) { //每页显示条数
              this.pageSize2 = val;
              this.currentPage2 = 1;
              this.getList2();
            },
            handleCurrentChange2(val) { //当前页
                this.currentPage2 = val;
                this.getList2(); //获取列表
            },
            getList1(){
                //获取列表
                let that = this;
                let param = {};
                param.page = that.currentPage1;
                param.pageSize = that.pageSize1;
                param.stationIds = that.selectList1;
                param.upOrDown = that.searchPark.upOrDown;
                param.barrierType = that.searchPark.barrierType;
                param.keyword = that.searchPark.keyword;
                // console.log(param);
                that.$axios.post(that.$store.state.platformApi+"park/page",JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        that.tableData1 = result.data.records;
                        that.total1 = result.data.total; 
                    }
                })
            },
            getList2(){
                //获取列表
                let that = this;
                let param = {};
                param.type = that.searchThird.type;
                param.page = that.currentPage2;
                param.pageSize = that.pageSize2;
                that.$axios.post(that.$store.state.platformApi+"barrier/config/page",JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        that.tableData2 = result.data.records;
                        that.total2 = result.data.total; 
                    }
                })
            },
            getConfigList(type){
                //获取道闸平台
                let that = this;
                let param = {};
                param.type = type;
                that.$axios.post(that.$store.state.platformApi+"barrier/config/list",JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        that.configOptions = result.data;
                    }
                })
            },
            getThirdObjList(oid){
                //获取安居宝同步场站列表
                let that = this;
                // console.log('oid---',oid);
                if(that.settingInfo.barrierType==2 && oid){
                    that.$axios.post(that.$store.state.platformApi+"park/anjubao/"+oid,{}).then(result => {
                        if(result.code==200){
                            that.thirdObjOptions = result.data;
                        }
                    })
                }
            },
            getThirdObj(id){
                //获取安居场站详情
                let that = this;
                let item = that.thirdObjOptions.find(item => item.id == id);
                if(item){
                    that.settingInfo.name = item.parkName;
                    that.settingInfo.code = item.parkCode;
                    that.settingInfo.merchantId = item.id;
                    that.settingInfo.address = item.address;
                    that.isAnjubao = true;
                }
            },
            getCouponList(){
                //获取停车减免列表
                let that = this;
                that.$axios.post(that.$store.state.platformApi+"park/coupon/list",{}).then(result => {
                    if(result.code==200){
                        that.couponOptions = result.data;
                    }
                })
            },
            checkChange1(val) {
                if (val) {
                    this.selectList1 = this.stationOptions.map(item => item.id); 
                }else {
                    this.selectList1 = []; 
                }
            },
            changeSelect1(val) {
                if (val.length === this.stationOptions.length) {
                    this.checked1 = true;
                }else {
                    this.checked1 = false; 
                }
            },
            checkChange2(val) {
                if (val) {
                    this.selectList2 = this.stationOptions.map(item => item.id); 
                }else {
                    this.selectList2 = []; 
                }
            },
            changeSelect2(val) {
                if (val.length === this.stationOptions.length) {
                    this.checked2 = true;
                }else {
                    this.checked2 = false; 
                }
            },
            checkChange3(val) {
                if (val) {
                    this.selectList3 = this.templateOptions.map(item => item.id); 
                }else {
                    this.selectList3 = []; 
                }
            },
            changeSelect3(val) {
                if (val.length === this.templateOptions.length) {
                    this.checked3 = true;
                }else {
                    this.checked3 = false; 
                }
            },
            handleClick(tab, event) {
                // console.log(this.activeState);
                if(this.activeState == 1 && !this.isLoadData){
                    this.getList2(); //获取列表
                    this.isLoadData = true;
                }
            },
            handleSelectionChange(val) {
                this.selection = val;
                // console.log('selection change: ', val); 
            },
            handleSelectionChange2(val) {
                this.selection2 = val;
                // console.log('selection change: ', val); 
            },
            typeFilter(value) {
                //过滤函数
                switch (value) {
                case 1:
                    return '捷停车';
                case 2:
                    return '安居宝';
                default:
                    return value;
                }
            },
            upOrDownFilter(value) {
                //过滤函数
                if (value == 1) {
                    return '地上';
                }else if (value == 2) {
                    return '地下';
                }else {
                    return value;
                }
            },
            barrierTypeFilter(value) {
                //过滤函数
                switch (value) {
                case 1:
                    return '捷停车';
                case 2:
                    return '安居宝';
                default:
                    return value;
                }
            },
        }
    };

</script>


<style lang="scss" scoped>
.checkboxWrapper {
  padding: 3px 20px;
  border-bottom: 1px solid #ccc;
}
</style>